import { CompanyInformationLocalization } from './types';

const companyInformation: CompanyInformationLocalization = {
  name: {
    DE: 'Swiss Alpinopharma GmbH',
    CH: 'Topmed AG',
  },
  street: {
    DE: 'Kurfürstendamm 207-208',
    CH: 'Steinenberg 23',
  },
  city: {
    DE: '10719 Berlin',
    CH: '4051 Basel',
  },
  phone: {
    DE: '+49 30 30807330',
    CH: '+41 061 416 08 00',
  },
  email: {
    DE: 'service@help.enmedify.com',
    CH: 'support@enmedify.ch',
  },
};

export default companyInformation;
